import { useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Outlet } from "react-router-dom";

export default function DashboardLayout() {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Sidebar - Fixed */}
      <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
      
      {/* Main content wrapper */}
      <div className="flex flex-col flex-1 min-w-0 h-screen overflow-hidden">
        {/* Navbar - Fixed at top */}
        <Navbar setIsOpen={setIsOpen} />
        
        {/* Scrollable content area with footer */}
        <div className="flex-1 overflow-y-auto">
          {/* Page Content */}
          <main className="p-6">
            <div className="max-w-full">
              <Outlet />
            </div>
          </main>
          
          {/* Footer - At bottom of scrollable content */}
          <Footer />
        </div>
      </div>
    </div>
  );
}